module.exports = __webpack_public_path__ + "static/media/magnifying-glass-icon.ac08c73c.svg";